/* eslint-disable object-shorthand */
/* eslint-disable no-lonely-if */
/* eslint-disable dot-notation */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Container, Typography, Stack, IconButton, InputAdornment, TextField, Paper, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { LoadingButton } from '@mui/lab';
import '../stylemod.css';
// hooks
import useResponsive from '../../hooks/useResponsive';
import logoImage from '../../media/login/logo2.png';
import bg4 from '../../media/login/bg13.jpg';
import Iconify from '../../components/iconify';
import axios from '../../utils/axios';

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundImage: `url("${bg4}")`,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  mixBlendMode: 'multiply',
}));

// Initial values and validation schema for Formik
const loginInitialValue = {
  usercode: '',
  password: '',
  code: '',
};

const minimalValidationSchema = Yup.object().shape({
  usercode: Yup.string().required('Enter your LoginCode'),
  code: Yup.string().required('Enter your Company Code'),
  password: Yup.string().max(15, 'Password is too long').required('Enter your password'),
});

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');
  const navigate = useNavigate();
  const [showUserPassword, setShowUserPassword] = useState(false);
  const [error, setError] = useState('');
  const [errorColor, setErrorColor] = useState('');
  const [loading, setLoading] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);

  const loginStatus = (msg, color, userDatas) => {
    setError(msg);
    setErrorColor(color);
    if (userDatas) {
      Object.entries({
        authToken: `${userDatas.authToken}`,
        UserCode: userDatas.User_Code,
        UserEmail: userDatas.User_Name,
        UserId: userDatas.User_Id,
        UserName: userDatas.User_Name,
        DesignationId: '1',
        Designation: 'admin',
      }).forEach(([key, value]) => sessionStorage.setItem(key, value));
      sessionStorage.setItem(`User_Master`, 'Y');
      setTimeout(() => {
        navigate(`/dashboard/Masters/Category`, { replace: true });
        setError('');
        setErrorColor('');
        setLoading(false);
      }, 2000);
    }
  };

  const handleClick = async ({ usercode: LoginCode, password: Password, code }) => {
    setLoading(true);
    try {
      const response = await axios.post(
        '/login',
        { LoginCode, Password },
        {
          headers: {
            companycode: code, // set header here
          },
        }
      );
      if (response.status === 200 && response.data.authToken) {
        // Set headers for future requests
        axios.defaults.headers.authToken = `${response.data.authToken}`;
        axios.defaults.headers.companycode = code;
        sessionStorage.setItem(`companycode`, code);
        loginStatus(`Welcome back, ${response.data.User_Name}! You’ve successfully logged in.`, 'green', response.data);
      } else {
        loginStatus('Invalid login credentials. Please try again.', 'error');
        setLoading(false);
      }
    } catch (e) {
      loginStatus(e.response?.data || 'Something Went Wrong!', 'error');
      setLoading(false);
    }
  };

  return (
    <>
      <StyledRoot>
        <StyledSection>
          <Container
            maxWidth="md"
            style={{
              backgroundColor: 'inherit',
              borderRadius: mdUp ? '50px' : 0,
              padding: mdUp ? '0 16px' : 0,
            }}
            component={Paper}
            elevation={0}
          >
            <Grid
              container
              style={{
                background: 'rgb(246 247 255)',
                boxShadow:
                  'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset',
                minHeight: mdUp ? '55vh' : '100vh',
                maxHeight: mdUp ? '100vh' : 'auto',
                borderRadius: mdUp ? '50px' : 0,
              }}
            >
              <Grid item xs={12} md={5} sx={{ maxHeight: mdUp ? '100%' : '30%' }}>
                <Stack
                  justifyContent={'center'}
                  direction={'column'}
                  alignItems={'center'}
                  height={'100%'}
                  className="font_style1"
                >
                  <Stack
                    justifyContent={'center'}
                    direction={'column'}
                    alignItems={'center'}
                    p={3}
                    sx={{ maxHeight: mdUp ? '100%' : 'auto' }}
                  >
                    <img
                      src={logoImage}
                      style={{
                        objectFit: 'contain',
                        maxWidth: mdUp ? '80%' : '80%',
                      }}
                      alt="techveel logo"
                    />
                    {mdUp ? (
                      <Typography
                        variant="h5"
                        textAlign={'center'}
                        gutterBottom
                        className="font_style2"
                        style={{ color: 'black' }}
                        mt={4}
                      >
                        Manage Your Website With Ease
                      </Typography>
                    ) : (
                      <Typography
                        variant="body2"
                        textAlign={'center'}
                        style={{ textTransform: 'uppercase' }}
                        gutterBottom
                        sx={{ marginTop: mdUp ? 'inherit' : '10px' }}
                      >
                        Welcome to <br />
                        <span style={{ textTransform: 'uppercase' }} className="font_style2">
                          ASK | Admin Panel
                        </span>
                      </Typography>
                    )}
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={12} md={7} justifyContent={'center'} alignItems={'center'}>
                <Stack
                  spacing={3}
                  sx={{ backgroundColor: 'white', p: 3, pb: 3, height: '100%' }}
                  style={{
                    borderTopRightRadius: mdUp ? '50px' : 0,
                    borderBottomRightRadius: mdUp ? '50px' : 0,
                  }}
                  justifyContent={'center'}
                >
                  <Grid container spacing={2} justifyContent={'center'} alignItems={'center'}>
                    <Grid item xs={12} p={0}>
                      {mdUp ? (
                        <Typography variant="body2" textAlign={'center'} gutterBottom>
                          Welcome to <br />
                          <span style={{ textTransform: 'uppercase', color: 'black' }} className="font_style2">
                            ASK | Admin Panel
                          </span>
                          <br />
                          <Typography
                            sx={{
                              color: forgotPassword ? 'error.main' : 'text.primary',
                            }}
                            fontSize={forgotPassword ? '1.175rem' : '0.875rem'}
                            variant="subtitle2"
                            textAlign={'center'}
                            gutterBottom
                          >
                            {forgotPassword ? 'Forgot Your Password' : 'Enter Your Credentials'}
                          </Typography>
                        </Typography>
                      ) : (
                        <Typography
                          sx={{
                            color: forgotPassword ? 'error.main' : 'text.primary',
                          }}
                          fontSize={forgotPassword ? '1.175rem' : '0.875rem'}
                          variant="subtitle2"
                          textAlign={'center'}
                          gutterBottom
                        >
                          {forgotPassword ? 'Forgot Your Password' : 'Enter Your Credentials'}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                  <Formik
                    validationSchema={minimalValidationSchema}
                    initialValues={loginInitialValue}
                    onSubmit={(values) => {
                      handleClick(values);
                    }}
                  >
                    {({ values, errors, submitForm, handleBlur, handleChange, touched }) => (
                      <Form>
                        <Grid container spacing={2} justifyContent={'center'} alignItems={'center'}>
                          <Grid item xs={12}>
                            <TextField
                              name="usercode"
                              label="User Name"
                              size="small"
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              value={values.usercode}
                              error={!!errors.usercode && touched.usercode}
                              helperText={touched.usercode && errors.usercode ? errors.usercode : ''}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              inputProps={{ autoComplete: 'off' }}
                              autoComplete="off"
                              onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                  submitForm();
                                }
                              }}
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              size="small"
                              fullWidth
                              name="password"
                              label="Password"
                              InputLabelProps={{ shrink: true }}
                              type={showUserPassword ? 'text' : 'password'}
                              autoComplete="off"
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment position="end">
                                    <IconButton onClick={() => setShowUserPassword(!showUserPassword)} edge="end">
                                      <Iconify icon={showUserPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                    </IconButton>
                                  </InputAdornment>
                                ),
                              }}
                              value={values.password}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={!!errors.password && touched.password}
                              helperText={touched.password && errors.password ? errors.password : ''}
                              onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                  submitForm();
                                }
                              }}
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <TextField
                              name="code"
                              label="Company Code"
                              size="small"
                              fullWidth
                              InputLabelProps={{ shrink: true }}
                              value={values.code}
                              error={!!errors.code && touched.code}
                              helperText={touched.code && errors.code ? errors.code : ''}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              inputProps={{ autoComplete: 'off' }}
                              autoComplete="off"
                              onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                  submitForm();
                                }
                              }}
                            />
                          </Grid>

                          {error && (
                            <Grid item xs={12}>
                              <Typography variant="body2" color={errorColor} sx={{ textAlign: 'center' }}>
                                {error}
                              </Typography>
                            </Grid>
                          )}

                          <Grid item xs={12}>
                            <LoadingButton
                              size="small"
                              fullWidth
                              type="button"
                              onClick={(e) => {
                                submitForm(e);
                                console.log(errors);
                              }}
                              variant="contained"
                              loading={loading}
                              color="info"
                              sx={{ bgcolor: '#2A4759', color: 'white' }}
                            >
                              {'Login'}
                            </LoadingButton>
                          </Grid>
                        </Grid>
                      </Form>
                    )}
                  </Formik>
                </Stack>
              </Grid>
            </Grid>
          </Container>
        </StyledSection>
      </StyledRoot>
    </>
  );
}
